import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, ref } from 'vue'
import { mdiPencilOutline, mdiPlus } from '@mdi/js'

import EventEditActionButtons from '@/pages/CreateEventProcessingPage/ui/layout/EventEditActionButtons.vue'
import { IEventEdit } from '@/enitites/event'
import { IEventTicketTier, IEventDiscountType, IEventDiscount } from '@/enitites/event/model/types'
import EditTicketTierModal from '@/pages/CreateEventProcessingPage/ui/EditTicketTierModal.vue'
import EditTicketDiscountModal from '@/pages/CreateEventProcessingPage/ui/EditTicketDiscountModal.vue'
import { centsToDollars } from '@/services/currency'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventTickets',
  props: {
    eventData: null
  },
  emits: ["next", "back", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'next'): void
  (e: 'back'): void
  (e: 'cancel'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  eventData: IEventEdit
};





const errorMessage = ref<string>()
const tabs = ['admission', 'promotions']
const selectedTab = ref('admission')
const ticketTierModal = reactive<{
  isOpen: boolean
  ticketTier: null | IEventTicketTier
}>({
  isOpen: false,
  ticketTier: null,
})
const discountModal = reactive<{
  isOpen: boolean
  discount: IEventDiscount | null
  discountType: IEventDiscountType | null
}>({
  isOpen: false,
  discount: null,
  discountType: 'code',
})

const ticketTiers = computed<IEventTicketTier[]>(() => {
  return [...(props.eventData.tiers || [])].sort((a, b) => a.id - b.id)
})
const discounts = computed<IEventDiscount[]>(() => {
  return [...(props.eventData.discounts || [])].sort((a, b) => a.id - b.id)
})

function getApplicableTicketTitles(discount: IEventDiscount) {
  if (!discount.applicableTicketTiers || discount.applicableTicketTiers.length === 0) {
    return 'All tickets'
  }
  return discount.applicableTicketTiers
    .map((tId) => {
      const tier = ticketTiers.value.find((tt) => tt.id === tId)
      return tier ? tier.tierTitle : 'Unknown tier'
    })
    .join(', ')
}

function closeTicketTierModal() {
  ticketTierModal.isOpen = false
  ticketTierModal.ticketTier = null
}

function addTicketTier() {
  ticketTierModal.isOpen = true
  ticketTierModal.ticketTier = null
}

function editTicketTier(tier: IEventTicketTier) {
  ticketTierModal.isOpen = true
  ticketTierModal.ticketTier = tier
}

function closeDiscountModal() {
  discountModal.isOpen = false
  discountModal.discount = null
  discountModal.discountType = null
}

function addDiscountCode() {
  discountModal.discountType = 'code'
  discountModal.isOpen = true
  discountModal.discount = null
}

function addEarlyBirdDiscount() {
  discountModal.discountType = 'early_bird'
  discountModal.isOpen = true
  discountModal.discount = null
}

function editDiscount(discount: IEventDiscount) {
  discountModal.isOpen = true
  discountModal.discount = discount
  discountModal.discountType = discount.type
}

const handleNextButton = () => {
  if (selectedTab.value === 'admission') {
    selectedTab.value = 'promotions'
  } else {
    emit('next')
  }
}

const handleBackButton = () => {
  if (selectedTab.value === 'promotions') {
    selectedTab.value = 'admission'
  } else {
    emit('back')
  }
}

onMounted(() => {
  if (props.eventData.tiers?.length === 0) {
    addTicketTier()
  }
})

return { __sfc: true,props, emit, errorMessage, tabs, selectedTab, ticketTierModal, discountModal, ticketTiers, discounts, getApplicableTicketTitles, closeTicketTierModal, addTicketTier, editTicketTier, closeDiscountModal, addDiscountCode, addEarlyBirdDiscount, editDiscount, handleNextButton, handleBackButton, mdiPencilOutline, mdiPlus, EventEditActionButtons, EditTicketTierModal, EditTicketDiscountModal, centsToDollars }
}

})